import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "22",
  viewBox: "0 0 24 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.667 19H24v-2.667h-5.333v-2.666l-4 4 4 4V19Zm-8-18.667c-2.934 0-5.334 2.4-5.334 5.334C5.333 8.6 7.733 11 10.667 11 13.6 11 16 8.6 16 5.667 16 2.733 13.6.333 10.667.333Zm0 2.667c1.466 0 2.666 1.2 2.666 2.667 0 1.466-1.2 2.666-2.666 2.666A2.675 2.675 0 0 1 8 5.667C8 4.2 9.2 3 10.667 3Zm0 9.333C7.067 12.333 0 14.067 0 17.667v4h12.667c-.4-.8-.534-1.6-.667-2.534H2.533v-1.466c0-.8 4.134-2.8 8.134-2.8.666 0 1.333.133 2 .133.4-.8.8-1.6 1.466-2.267-1.333-.266-2.533-.4-3.466-.4Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-account-arrow-left-outline"}) } }